import axios from 'axios';
import queryString from 'query-string';

const AUTH_PARTNER_BASE_URL = `${ process.env.REACT_APP_MS_AUTHENTICATION_PARTNER_SECURE }`;

export const getPartnerUserSuggestions = (keyword, queryParams) => {
   return axios.get(`${ AUTH_PARTNER_BASE_URL }allUser?name=${ keyword }&${ queryString.stringify(queryParams) }`);
};

export const getPartnerUserImpersonationSuggestions = ({ keyword }) => {
   return axios.get(`${ AUTH_PARTNER_BASE_URL }allExternal?name=${ keyword }`);
};

export const impersonateAsPartnerUser = (userId) => {
   return axios.get(`${ AUTH_PARTNER_BASE_URL }impersonate?userId=${ userId }`);
};

export const cancelImpersonateAsPartnerUser = () => {
   return axios.get(`${ AUTH_PARTNER_BASE_URL }back2admin`);
};
